import { Badge } from '@mantine/core';
import React from 'react';
import classes from './CustomListBadge.module.css';

export const CustomListBadge: React.FC<{ name: string; className?: string }> = (
  props
) => {
  return (
    <span className={classes.container}>
      <Badge className={`${classes.badge} ${props.className}`}>
        {props.name}
      </Badge>
    </span>
  );
};
